import React from 'react'
import AnonymousView from '../anonymous-view'

const AnonymousViewDe = () => {
    return <AnonymousView languageCode="de" />
}

export default AnonymousViewDe
